import Vue from 'vue';

export default (data) => {
    return Vue.Api.Post(data.API_URL, data.params);
};
